(function () {
  const money = (amount, currency) => {
    const value = Number(amount || 0);
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: currency || 'ZAR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value).replace(/\u00a0/g, '');
  };

  const selectedLabels = (root) => {
    return Array.from(root.querySelectorAll('variant-selects input[type="radio"]:checked'))
      .map((input) => input.value)
      .filter(Boolean);
  };

  const displayLabels = (root) => {
    return selectedLabels(root).map((value) => (/^unframed$/i.test(value) ? 'Print only' : value));
  };

  const cleanMoney = (text) => {
    const source = String(text || '').replace(/\u00a0/g, ' ').trim();
    const match = source.match(/R\s*([\d,.]+)/i);
    if (!match) return source;
    const amount = Number(match[1].replace(/,/g, ''));
    if (!Number.isFinite(amount)) return source;
    const formatted = new Intl.NumberFormat('en-ZA', {
      minimumFractionDigits: amount % 1 ? 2 : 0,
      maximumFractionDigits: amount % 1 ? 2 : 0
    }).format(amount).replace(/\u00a0/g, '');
    return `${/^from\b/i.test(source) ? 'From ' : ''}R${formatted}`;
  };

  const formatPrices = (scope) => {
    (scope || document).querySelectorAll('.price-item').forEach((node) => {
      const formatted = cleanMoney(node.textContent);
      if (formatted && node.textContent.trim() !== formatted) node.textContent = formatted;
    });
  };

  const selectedPrice = (root) => {
    const price = root.querySelector('.price-item--sale, .price-item--regular');
    return price ? cleanMoney(price.textContent) : '';
  };

  const updateProductUI = (root) => {
    if (!root) return;
    formatPrices(root);
    const values = selectedLabels(root);
    const price = selectedPrice(root);
    const priceHost = root.querySelector('[id^="price-"]');
    if (priceHost) {
      priceHost.classList.add('deco-price-row');
      let hint = priceHost.querySelector('.deco-variant-hint');
      if (!hint) {
        hint = document.createElement('span');
        hint.className = 'deco-variant-hint';
        priceHost.appendChild(hint);
      }
      hint.textContent = values.join(' · ');
    }
    const atc = root.querySelector('.product-form__submit:not([disabled]) > span');
    if (atc && price) atc.textContent = `Add to cart — ${price}`;

    const nudge = root.querySelector('[data-deco-format-nudge]');
    if (nudge) {
      const printOnly = values.some((value) => /unframed|print only/i.test(value));
      nudge.hidden = !printOnly;
    }

    const bar = document.querySelector('[data-deco-mobile-buybar]');
    if (bar) {
      const detail = bar.querySelector('[data-deco-mobile-detail]');
      if (detail) detail.textContent = [price, values.join(' · ')].filter(Boolean).join(' · ');
      const button = bar.querySelector('button');
      const mainButton = root.querySelector('.product-form__submit');
      if (button && mainButton) {
        button.disabled = mainButton.disabled;
        button.textContent = mainButton.disabled ? 'Unavailable' : 'Add to cart';
      }
    }
  };

  const ensureViewCartAction = (root) => {
    const buttons = root?.querySelector('.product-form__buttons');
    if (!buttons) return null;
    let link = buttons.querySelector('[data-deco-view-cart]');
    if (!link) {
      link = document.createElement('a');
      link.className = 'deco-view-cart';
      link.dataset.decoViewCart = '';
      link.href = window.routes?.cart_url || '/cart';
      link.textContent = 'View cart →';
      link.hidden = true;
      buttons.appendChild(link);
    }
    return link;
  };

  let addedStateTimer;
  const showAddedState = (root) => {
    if (!root) return;
    const button = root.querySelector('.product-form__submit:not([disabled])');
    const label = button?.querySelector(':scope > span');
    if (!button || !label) return;

    const selection = displayLabels(root).join(' · ');
    button.classList.add('deco-product-added');
    button.dataset.decoAdded = 'true';
    label.textContent = `Added${selection ? ` — ${selection}` : ''}`;
    button.setAttribute('aria-label', `Added${selection ? ` ${selection}` : ''}. Click to add another.`);

    const viewCart = ensureViewCartAction(root);
    if (viewCart) viewCart.hidden = false;

    window.clearTimeout(addedStateTimer);
    addedStateTimer = window.setTimeout(() => {
      button.classList.remove('deco-product-added');
      delete button.dataset.decoAdded;
      button.removeAttribute('aria-label');
      updateProductUI(root);
    }, 3200);
  };

  const workingDay = () => {
    const date = new Date();
    let added = 0;
    while (added < 6) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
    }
    return new Intl.DateTimeFormat('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' }).format(date);
  };

  const setDeliveryDates = () => {
    document.querySelectorAll('[data-deco-delivery-date]').forEach((node) => {
      node.textContent = workingDay();
    });
  };

  const initZoom = () => {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('product-info .product__media-item:first-child .product__media').forEach((frame) => {
      const image = frame.querySelector('img');
      if (!image || frame.dataset.decoZoomReady) return;
      frame.dataset.decoZoomReady = 'true';
      frame.addEventListener('mousemove', (event) => {
        const box = frame.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width) * 100;
        const y = ((event.clientY - box.top) / box.height) * 100;
        image.style.transformOrigin = `${x}% ${y}%`;
        image.style.transform = 'scale(1.5)';
      });
      frame.addEventListener('mouseleave', () => {
        image.style.transform = '';
        image.style.transformOrigin = '';
      });
    });
  };

  const decorateFramePills = (root) => {
    if (!root) return;
    root.querySelectorAll('.product-form__input--pill label').forEach((label) => {
      const value = label.textContent.trim().toLowerCase();
      const chips = {
        black: '#1C0003',
        white: '#FAF8F5',
        wood: 'linear-gradient(135deg,#b08954,#8a6a3e)'
      };
      if (chips[value]) {
        label.classList.add('deco-frame-label');
        label.style.setProperty('--deco-frame-chip', chips[value]);
      }
    });
  };

  const syncSizeGuide = (root) => {
    if (!root) return;
    const availableSizes = new Set(
      Array.from(root.querySelectorAll('variant-selects input[type="radio"]'))
        .map((input) => input.value.trim().toUpperCase())
        .filter((value) => /^A[1-4]$/.test(value))
    );
    document.querySelectorAll('[data-deco-size]').forEach((choice) => {
      const available = availableSizes.has(choice.dataset.decoSize.toUpperCase());
      choice.classList.toggle('deco-size-choice--unavailable', !available);
      choice.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.removeAttribute('open');
    document.documentElement.style.overflow = '';
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-deco-size-guide-open]');
    if (open) {
      const modal = document.querySelector('[data-deco-size-modal]');
      if (modal) {
        modal.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        modal.querySelector('.deco-size-modal__close')?.focus();
      }
      return;
    }

    const modal = event.target.closest('[data-deco-size-modal]');
    if (event.target.closest('[data-deco-size-modal-close]') || (modal && event.target === modal)) {
      closeModal(modal || document.querySelector('[data-deco-size-modal]'));
      return;
    }

    const size = event.target.closest('[data-deco-size]');
    if (size) {
      const value = size.dataset.decoSize;
      const root = document.querySelector('product-info');
      const input = Array.from(root?.querySelectorAll('variant-selects input[type="radio"]') || [])
        .find((candidate) => candidate.value.toUpperCase() === value.toUpperCase());
      if (input && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      closeModal(document.querySelector('[data-deco-size-modal]'));
      return;
    }

    const stickyButton = event.target.closest('[data-deco-mobile-buybar] button');
    if (stickyButton) document.querySelector('product-info .product-form__submit:not([disabled])')?.click();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal(document.querySelector('[data-deco-size-modal][open]'));
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      const root = document.querySelector('product-info');
      root?.querySelector('.product-form__submit')?.classList.remove('deco-product-added');
      window.setTimeout(() => updateProductUI(document.querySelector('product-info')), 180);
    }
  });

  const init = () => {
    setDeliveryDates();
    const root = document.querySelector('product-info');
    decorateFramePills(root);
    syncSizeGuide(root);
    formatPrices(document);
    updateProductUI(root);
    ensureViewCartAction(root);
    initZoom();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'product-form') showAddedState(document.querySelector('product-info'));
    });
  }

  const priceObserver = new MutationObserver(() => formatPrices(document));
  priceObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
